import UploadFilesMlt from "./UploadFilesMlt.jsx";

const SummaryEventMlt = () => {

  const content = (
    <div className="col-md-9 mb-5">
      <UploadFilesMlt></UploadFilesMlt>
    </div>
  )
  return content
}

export default SummaryEventMlt;